import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "FuerzaPage",
    data() {
        let ss = new MainService();
        return {
            msg: "FuerzaPage",
            ss: ss,
            ajax: {
                "url": ss.indexFuerza(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Fuerza', name: 'Fuerza', title: 'Fuerza' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            fuerzas: [],
            fuerza: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newFuerza() {
            this.fuerza = {};
            this.$refs['frm-fuerza'].show();
        },
        showFuerza(id) {
            this.isLoading=true;
            this.ss.showFuerza(id).then(
                (result) => {
                    let response = result.data;
                    this.fuerza = response.data;
                    this.$refs['view-fuerza'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editFuerza() {
            this.$refs['frm-fuerza'].show();
            this.$refs['view-fuerza'].hide();
        },
        cancelFuerza() {
            if (this.fuerza.id) {
                this.$refs['view-fuerza'].show();
            }
            this.$refs['frm-fuerza'].hide();
        },
        saveFuerza() {
            this.ss.storeFuerza(this.fuerza).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-fuerza'].hide();
                    this.$refs['datatable-fuerza'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteFuerza() {
            this.$swal({
                title: "¿Estás seguro que deseas eliminar?",
                text: "¿Esta acción es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyFuerza(this.banco)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-fuerza'].hide();
                                this.$refs['datatable-fuerza'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Fuerza').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showFuerza(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
